import TextField from '@mui/material/TextField';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {StaticDatePicker} from '@mui/x-date-pickers/StaticDatePicker';
import React, {useContext, useState} from "react";
import {useEffect} from "react";
import {Box, Chip, Grid, useTheme} from "@mui/material";
import {useHistory} from "react-router-dom";
import {encode} from 'js-base64';
import Typography from "@mui/material/Typography";
import useCallDataApi from "../hooks/data";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {hu} from "date-fns/locale";
import ReservationContext from "../context/ReservationContext";
import {formatHuman} from "../utils/Utils";
import Loading from "../components/Loading";

const Slot = ({ time, ...rest }) => {
    const theme = useTheme();
    return (
        <Chip
            {...rest}
            label={`${time.start} - ${time.end}`}
            style={{
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.primary["20"],
                fontWeight: 600,
                minWidth: "unset",       // remove enforced min-width
                maxWidth: "none",        // allow full width
                whiteSpace: "nowrap",    // prevent breaking
            }}
        />
    );
};


const NoAvailableTime = () => <Box sx={{width: '100%', justifyContent: 'center', alignItems: 'center', alignSelf: 'center'}}>
    <Typography variant="subtitle1" align="center">Erre a napra nincsenek szabad időpontok!</Typography>
    <Typography variant="body2" gutterBottom align="center">Válassz másik időpontot!</Typography>
</Box>


const AvailableTime = ({slots, proceed, selectedDate}) => {
    return <>
        <Typography variant="subtitle2" align="center">Szabad időpontok - {formatHuman(selectedDate)}</Typography>
        <Typography variant="body2" gutterBottom align="center">Válassz szabad időpontot az alábbiak közül!</Typography>
        <Grid container spacing={1}>
            {slots.map((s, i) => <Grid style={{display: 'flex', justifyContent: 'center'}} item xs={4} xl={4} key={`slot_${i}`}>
                <Slot time={s} onClick={() => proceed(s)}/>
            </Grid>)}
        </Grid>
    </>
}


const SelectDate = () => {
    const today = new Date()
    const {getData: fetchData, postData} = useCallDataApi('sp-reserve')
    const {next, selected} = useContext(ReservationContext)
    const [selectedDate, setSelectedDate] = useState(null)
    const [availability, setAvailability] = useState({})
    const [slots, setSlots] = useState([])
    const [month, setMonth] = useState(today.getMonth() + 1)
    const [year, setYear] = useState(today.getFullYear())
    const [loading, setLoading] = useState(false)
    const history = useHistory()

    const toUriSafe = (s) => {
        let encoded = encode(formatHuman(selectedDate) + '|' + s.start + '|' + s.end);
        return encoded.replace('==', '');
    }

    const getMaxDate = (numberOfDays) => {
        const date = new Date();
        date.setDate(date.getDate() + numberOfDays);
        return date;
    }

    useEffect(() => {
        if (!selected?.price) return;
        setLoading(true)
        postData('monthly_availability/', {year: year, month: month, price: selected?.price?.id})
            .then(a => {
                setAvailability(a?.data || {})
                if (!selectedDate && a?.data) {
                    const today = new Date();
                    const firstAvailable = Object.entries(a.data)
                        .find(([date, available]) => {
                            if (!available) return false;
                            const d = new Date(date);
                            // Only select if date is after today (ignoring time)
                            return d > new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        });
                    if (firstAvailable) {
                        setSelectedDate(new Date(firstAvailable[0]))
                    }
                }
            })
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected?.price, year, month])

    useEffect(() => {
        if (!selectedDate || !selected?.price) return;
        setLoading(true)
        const getData = async () => {
            const [s, a] = await Promise.all([
                fetchData(`get_free_slots_for_date/?price=${selected?.price?.id}&date=${formatHuman(selectedDate)}`),
                postData('monthly_availability/', {year: year, month: month, price: selected?.price?.id})
            ])
            if (s) setSlots(s)
            if (a) setAvailability(a?.data)
        }
        getData()
            .catch(e => console.log(e))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate, selected?.price])

    const isAvailableForReserve = (date) => !availability[formatHuman(date)]

    const proceed = (d) => {
        next({...selected, date: toUriSafe(d)})
        history.push({
            pathname: '/book',
            search: `?c=${selected?.category?.id}&s=${selected?.service?.id}&p=${selected?.price?.id}&d=${toUriSafe(d)}`
        })
    }

    const monthChange = (d) => {
        setLoading(true)
        const selectedMonth = d.getMonth() + 1
        const selectedYear = d.getFullYear()
        setMonth(selectedMonth)
        setYear(selectedYear)
        postData('monthly_availability/', {year: selectedYear, month: selectedMonth, price: selected?.price?.id})
            .then(r => setAvailability(r.data))
            .finally(() => setLoading(false))
    }

    return <div className="data-container">
        <div className="date-select-container">
            <div className="date-select-calendar">
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={hu}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        disablePast
                        openTo="day"
                        maxDate={getMaxDate(selected?.service?.accept_until)}
                        shouldDisableDate={isAvailableForReserve}
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        onMonthChange={(d) => monthChange(d)}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
            </div>
            <div className="data-container-slots" style={slots.length !== 0 ? {} : {display: 'flex'}}>
                {slots.length !== 0 ? <AvailableTime slots={slots} proceed={proceed} selectedDate={selectedDate}/>: <NoAvailableTime/>}
            </div>
        </div>

        <Loading isLoading={loading}/>
    </div>
}

export default SelectDate